import { getFulfillmentDayForDate } from "@redotech/redo-fulfillment-group-common/marketplace-fulfillment-settings";
import { useTranslation } from "@redotech/redo-i18n";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoSingleDatePicker } from "@redotech/redo-web/arbiter-components/date-picker/redo-single-date-picker";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { useMerchantTimeZone } from "../utils/use-merchant-time-zone";

/** Shows a fulfill-by date as its calendar day in the merchant time zone. */
export const FulfillByDatePicker = memo(function FulfillByDatePicker({
  date,
  onChange,
  clearable,
  disabled,
}: {
  date: Date | null;
  onChange: (day: Temporal.PlainDate | null) => void;
  clearable: boolean;
  disabled?: boolean;
}) {
  const { t } = useTranslation();
  const timeZone = useMerchantTimeZone();

  return (
    <Flex dir="column" gap="xs">
      <Text fontSize="xs" textColor="secondary">
        {t("Fulfill by")}
      </Text>
      <Flex align="center" gap="sm">
        <RedoSingleDatePicker
          buttonSize="sm"
          date={
            date
              ? Temporal.PlainDate.from(
                  getFulfillmentDayForDate({ fulfillmentDate: date, timeZone }),
                )
              : undefined
          }
          disabled={disabled}
          setDate={onChange}
        />
        {clearable && (
          <RedoButton
            disabled={disabled}
            hierarchy="tertiary"
            onClick={() => onChange(null)}
            size="sm"
            text={t("Clear")}
            theme="normal"
          />
        )}
      </Flex>
    </Flex>
  );
});
